import { DataBean } from "../DataBean";

export class Article extends DataBean {



    public async getAdquisitionArticleConstants(id: any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionArticleConstants_Number", [id]);
    }

}